export const version = "transactions/5.4.0";
//# sourceMappingURL=_version.js.map